'use client';

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { MainContent } from '@src/components/a11y/MainContent/MainContent';
export function MainLandmark(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <MainContent>{children}</MainContent>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}